import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NavLinks } from '../../../nav-links';

import { CommercialService, UserService } from '@core/services';
import { User } from '@shared/models';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {

  public navLinks: any;
  public customerServiceLinks: any;
  private commercialSubscription: Subscription;
  public commercial: any;
  private userSubscription: Subscription;
  public user: User;

  constructor(
    private _commercial: CommercialService,
    private _userService: UserService
  ) {

  }

  ngOnInit() {

    this.navLinks = NavLinks.NAV_LINKS;
    this.customerServiceLinks = NavLinks.CUSTOMER_SERVICE_LINKS;

    this.commercialSubscription = this._commercial.getCommercialValue()
      .subscribe(commercial => this.commercial = commercial);

    this.userSubscription = this._userService.getUser()
      .subscribe(user => this.user = user);

  }

  ngOnDestroy(){
    if(this.commercialSubscription)
      this.commercialSubscription.unsubscribe();
    if(this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  hasProperty(obj: object, property: string) {
    return obj.hasOwnProperty(property);
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/components/sidebar/sidebar.component.ts